<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <!-- 顶部门店选择 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline">
            <a-row :gutter="24">
              <a-col :md="8" :sm="24">
                <a-form-item label="所属门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="storeId" placeholder="请选择门店" @change="onStoreChange">
                    <a-select-option v-for="s in storeOptionList" :key="s.id" :value="s.id">{{ s.name }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <a-tabs v-model="activeTab">
          <!-- 桌台管理 -->
          <a-tab-pane tab="桌台管理" key="table">
            <div class="table-page-search-wrapper">
              <a-form layout="inline" @keyup.enter.native="searchQuery">
                <a-row :gutter="24">
                  <a-col :md="6" :sm="24">
                    <a-form-item label="区域" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select v-model="queryParam.areaId" placeholder="全部区域" allow-clear>
                        <a-select-option v-for="a in areas" :key="a.id" :value="a.id">{{ a.name }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-select v-model="queryParam.status" placeholder="全部状态" allow-clear>
                        <a-select-option value="idle">空闲</a-select-option>
                        <a-select-option value="occupied">占用</a-select-option>
                        <a-select-option value="reserved">预定</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="12" :sm="24">
                    <a-button type="primary" @click="searchQuery">查询</a-button>
                    <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                    <a-button v-if="btnEnableList.indexOf(1)>-1" style="margin-left: 8px" type="primary" icon="plus" @click="handleTableAdd">新增桌台</a-button>
                    <a-button style="margin-left: 8px" icon="printer" @click="handlePrint">打印桌码</a-button>
                  </a-col>
                </a-row>
              </a-form>
            </div>
            <a-table
              size="middle"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :scroll="scroll"
              :loading="loading"
              :pagination="false">
              <span slot="action" slot-scope="text, record">
                <a @click="handleTableEdit(record)">编辑</a>
                <a-divider type="vertical" />
                <a @click="handleTableQr(record)">桌码</a>
                <a-divider type="vertical" />
                <a v-if="btnEnableList.indexOf(1)>-1" @click="handleTableDelete(record)">删除</a>
              </span>
              <template slot="statusSlot" slot-scope="text">
                <a-tag :color="statusColor[text] || 'blue'">{{ statusText[text] || text }}</a-tag>
              </template>
              <template slot="orderSlot" slot-scope="text">
                <span v-if="text">{{ text }}</span>
                <span v-else>-</span>
              </template>
            </a-table>
          </a-tab-pane>
          <!-- 区域管理 -->
          <a-tab-pane tab="区域管理" key="area">
            <div class="table-operator">
              <a-button v-if="btnEnableList.indexOf(1)>-1" @click="handleAreaAdd" type="primary" icon="plus">新增区域</a-button>
            </div>
            <a-table
              size="middle"
              bordered
              rowKey="id"
              :columns="areaColumns"
              :dataSource="areas"
              :pagination="false">
              <span slot="areaAction" slot-scope="text, record">
                <a @click="handleAreaEdit(record)">编辑</a>
                <a-divider type="vertical" />
                <a v-if="btnEnableList.indexOf(1)>-1" @click="handleAreaDelete(record)">删除</a>
              </span>
            </a-table>
          </a-tab-pane>
          <!-- 桌型管理 -->
          <a-tab-pane tab="桌型管理" key="type">
            <div class="table-operator">
              <a-button v-if="btnEnableList.indexOf(1)>-1" @click="handleTypeAdd" type="primary" icon="plus">新增桌型</a-button>
            </div>
            <a-table
              size="middle"
              bordered
              rowKey="id"
              :columns="typeColumns"
              :dataSource="types"
              :pagination="false">
              <span slot="typeAction" slot-scope="text, record">
                <a @click="handleTypeEdit(record)">编辑</a>
                <a-divider type="vertical" />
                <a v-if="btnEnableList.indexOf(1)>-1" @click="handleTypeDelete(record)">删除</a>
              </span>
            </a-table>
          </a-tab-pane>
        </a-tabs>
        <!-- 弹窗区域 -->
        <area-modal ref="areaModal" :store-id="storeId" @ok="loadData"></area-modal>
        <table-type-modal ref="typeModal" :store-id="storeId" @ok="loadData"></table-type-modal>
        <table-modal ref="tableModal" :store-id="storeId" :areas="areas" :types="types" @ok="loadData"></table-modal>
        <table-qr-modal ref="qrModal"></table-qr-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { storeOptions, areaList, areaDelete, tableTypeList, tableTypeDelete,
  tableList, tableDelete, tablePrintData } from '@/api/plugin/dining'
import AreaModal from './AreaModal'
import TableTypeModal from './TableTypeModal'
import TableModal from './TableModal'
import TableQrModal from './TableQrModal'

const PRINT_PAGE_SIZE = 12 // A4 每页 3列×4行=12 张桌码卡

export default {
  name: 'DiningTableList',
  mixins: [JeecgListMixin],
  components: {
    AreaModal,
    TableTypeModal,
    TableModal,
    TableQrModal
  },
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 18, offset: 1 },
      activeTab: 'table',
      storeOptionList: [],
      storeId: null,
      areas: [],
      types: [],
      queryParam: {},
      urlPath: '/plugin/dining/table',
      statusText: { idle: '空闲', occupied: '占用', reserved: '预定' },
      statusColor: { idle: 'green', occupied: 'red', reserved: 'orange' },
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 50,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        { title: '操作', dataIndex: 'action', width: 130, align: 'center', scopedSlots: { customRender: 'action' } },
        { title: '桌台名', dataIndex: 'name', width: 110, align: 'left' },
        { title: '区域', dataIndex: 'areaName', width: 100, align: 'left', customRender: t => t || '-' },
        { title: '桌型', dataIndex: 'tableTypeName', width: 100, align: 'left', customRender: t => t || '-' },
        { title: '可坐人数', dataIndex: 'capacity', width: 80, align: 'center' },
        { title: '状态', dataIndex: 'status', width: 70, align: 'center', scopedSlots: { customRender: 'statusSlot' } },
        { title: '当前订单', dataIndex: 'orderNo', width: 140, align: 'left', scopedSlots: { customRender: 'orderSlot' } }
      ],
      areaColumns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        { title: '操作', dataIndex: 'action', width: 110, align: 'center', scopedSlots: { customRender: 'areaAction' } },
        { title: '区域名称', dataIndex: 'name', align: 'left' },
        { title: '排序', dataIndex: 'sort', width: 100, align: 'center' },
        { title: '桌台数', dataIndex: 'tableCount', width: 120, align: 'center' }
      ],
      typeColumns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        { title: '操作', dataIndex: 'action', width: 110, align: 'center', scopedSlots: { customRender: 'typeAction' } },
        { title: '桌型名称', dataIndex: 'name', align: 'left' },
        { title: '最少人数', dataIndex: 'minCapacity', width: 100, align: 'center' },
        { title: '最多人数', dataIndex: 'maxCapacity', width: 100, align: 'center' },
        { title: '保底消费(元)', dataIndex: 'lowestConsume', width: 120, align: 'right' }
      ]
    }
  },
  created() {
    // 启用门店下拉（主店在前），默认选中第一个并加载数据
    storeOptions().then(res => {
      if (res.code === 200) {
        this.storeOptionList = res.data || []
        if (this.storeOptionList.length) {
          this.storeId = this.storeOptionList[0].id
          this.loadData()
        }
      } else {
        this.$message.warning(res.message)
      }
    })
  },
  methods: {
    // 覆写 mixin：区域/桌型/桌台三份数据按当前门店一次性加载（桌台支持区域/状态筛选）
    loadData() {
      if (!this.storeId) {
        return
      }
      this.loading = true
      const params = { storeId: this.storeId }
      if (this.queryParam.areaId) {
        params.areaId = this.queryParam.areaId
      }
      if (this.queryParam.status) {
        params.status = this.queryParam.status
      }
      areaList({ storeId: this.storeId }).then(res => {
        if (res.code === 200) {
          this.areas = res.data || []
        }
      })
      tableTypeList({ storeId: this.storeId }).then(res => {
        if (res.code === 200) {
          this.types = res.data || []
        }
      })
      tableList(params).then(res => {
        if (res.code === 200) {
          this.dataSource = res.data || []
        } else {
          this.$message.warning(res.message)
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    onStoreChange() {
      this.queryParam = {}
      this.loadData()
    },
    // ===== 区域 =====
    handleAreaAdd() {
      if (!this.storeId) {
        return
      }
      this.$refs.areaModal.add()
      this.$refs.areaModal.title = '新增区域'
    },
    handleAreaEdit(record) {
      this.$refs.areaModal.edit(record)
      this.$refs.areaModal.title = '编辑区域'
    },
    handleAreaDelete(record) {
      const that = this
      this.$confirm({
        title: '删除确认',
        content: '确定删除区域「' + record.name + '」吗？',
        onOk() {
          // 区域下有桌台时后端保护拒绝，直接展示后端 message
          return areaDelete(record.id).then(res => {
            if (res.code === 200) {
              that.$message.success(res.message)
              that.loadData()
            } else {
              that.$message.warning(res.message)
            }
          })
        }
      })
    },
    // ===== 桌型 =====
    handleTypeAdd() {
      if (!this.storeId) {
        return
      }
      this.$refs.typeModal.add()
      this.$refs.typeModal.title = '新增桌型'
    },
    handleTypeEdit(record) {
      this.$refs.typeModal.edit(record)
      this.$refs.typeModal.title = '编辑桌型'
    },
    handleTypeDelete(record) {
      const that = this
      this.$confirm({
        title: '删除确认',
        content: '确定删除桌型「' + record.name + '」吗？',
        onOk() {
          return tableTypeDelete(record.id).then(res => {
            if (res.code === 200) {
              that.$message.success(res.message)
              that.loadData()
            } else {
              that.$message.warning(res.message)
            }
          })
        }
      })
    },
    // ===== 桌台 =====
    handleTableAdd() {
      if (!this.storeId) {
        return
      }
      if (!this.areas.length) {
        this.$message.warning('请先在「区域管理」中创建区域')
        return
      }
      this.$refs.tableModal.add()
      this.$refs.tableModal.title = '新增桌台'
    },
    handleTableEdit(record) {
      this.$refs.tableModal.edit(record)
      this.$refs.tableModal.title = '编辑桌台'
    },
    handleTableQr(record) {
      this.$refs.qrModal.show(record)
    },
    handleTableDelete(record) {
      const that = this
      this.$confirm({
        title: '删除确认',
        content: '确定删除桌台「' + record.name + '」吗？',
        onOk() {
          return tableDelete(record.id).then(res => {
            if (res.code === 200) {
              that.$message.success(res.message)
              that.loadData()
            } else {
              that.$message.warning(res.message)
            }
          })
        }
      })
    },
    // ===== 批量打印桌码：新窗口写入 A4 排版 HTML（每页 3×4=12 张：桌台名大字+二维码+店名）=====
    handlePrint() {
      if (!this.storeId) {
        return
      }
      const params = { storeId: this.storeId }
      if (this.queryParam.areaId) {
        params.areaId = this.queryParam.areaId
      }
      tablePrintData(params).then(res => {
        if (res.code === 200) {
          this.openPrintWindow(res.data || {})
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    openPrintWindow(data) {
      const items = data.items || []
      if (!items.length) {
        this.$message.warning('当前范围没有可打印的桌码')
        return
      }
      const win = window.open('', '_blank')
      if (!win) {
        this.$message.warning('浏览器拦截了弹出窗口，请允许弹窗后重试')
        return
      }
      const pages = []
      for (let i = 0; i < items.length; i += PRINT_PAGE_SIZE) {
        pages.push(items.slice(i, i + PRINT_PAGE_SIZE))
      }
      const pagesHtml = pages.map(page => '<div class="page">' + page.map(item =>
        '<div class="card">' +
        '<div class="card-table">' + this.escapeHtml(item.tableName) + '</div>' +
        '<img class="card-qr" src="data:image/png;base64,' + item.qrBase64 + '" />' +
        '<div class="card-store">' + this.escapeHtml(data.storeName) + '</div>' +
        '</div>').join('') + '</div>').join('')
      win.document.write('<!DOCTYPE html><html><head><meta charset="utf-8"><title>桌码打印</title><style>' +
        '@page{size:A4;margin:8mm}' +
        'body{margin:0;font-family:"Microsoft YaHei","PingFang SC",sans-serif}' +
        '.page{display:flex;flex-wrap:wrap;width:194mm;page-break-after:always}' +
        '.page:last-child{page-break-after:auto}' +
        '.card{box-sizing:border-box;width:33.33%;height:68mm;border:1px dashed #bbb;' +
        'display:flex;flex-direction:column;align-items:center;justify-content:center;padding:3mm}' +
        '.card-table{font-size:24pt;font-weight:bold;color:#222}' +
        '.card-qr{width:36mm;height:36mm;margin-top:3mm}' +
        '.card-store{font-size:12pt;color:#555;margin-top:2mm}' +
        '</style></head><body>' + pagesHtml + '</body></html>')
      win.document.close()
      win.focus()
      setTimeout(() => {
        win.print()
      }, 300)
    },
    escapeHtml(text) {
      return String(text == null ? '' : text)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;')
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less'
</style>
